/**
 * A top-left back arrow which navigates to the previous page in history.
 *
 * Used in Registration and Forgot password screens.
 */
import React from 'react'
import { Link } from 'react-router-dom'
import caretLeftIcon from '../../assets/icons/caretLeft.svg'

export function BackToLoginLink() {
    return (
        <Link to="/login" className="flex items-center gap-2.5 mb-10 pl-5 pt-6 md:pl-8">
            <img src={caretLeftIcon} alt="Navigation icon" />
            <span>Natrag</span>
        </Link>
    )
}
